<template>
  <div>
    <el-card class="self-el-card">
      <p style="font-weight: bold">基本信息</p>
      <el-form ref="form" label-width="200px" style="padding-bottom: 30">
        <el-form-item label="名称：" class="is-required">
          <el-input
            v-model.trim="name"
            placeholder="请输入..."
            class="width_short"
            maxlength="30"
            size="small"
          ></el-input>
          <span>30个字以内</span>
        </el-form-item>
        <el-form-item label="订单媒介名称：" class="is-required">
          <el-input
            v-model="orderIntermediaryName"
            placeholder="请输入..."
            class="width_short"
            maxlength="10"
            size="small"
          ></el-input>
          <span>10个字以内</span>
        </el-form-item>
        <el-form-item label="订单会员类型：" class="is-required">
          <el-radio-group v-model="formValue.vipType">
            <el-radio :label="1">团购会员</el-radio>
            <el-radio :label="2">个人会员</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="自动开通人数设置：" class="is-required" v-if="formValue.vipType === 1">
          <el-input-number
            v-model="formValue.autoOpenNum"
            :min="5"
            :max="9999"
            :step="1"
            :precision="0"
            size="small"
          ></el-input-number>
        </el-form-item>
        <div class="pay-success-card">
          <el-form-item label="开启引流">
            <el-switch
              v-model="formValue.drainStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="ENABLED"
              inactive-value="DISABLED"
              :disabled="isDisabled"
            ></el-switch>
          </el-form-item>
          <section v-if="formValue.drainStatus === 'ENABLED'">
            <el-form-item label="提示文案" class="is-required" prop="drainTips">
              <el-input class="box-input" v-model="formValue.drainTips" maxlength="14" clearable></el-input>
              <span class="desc">14个字以内</span>
            </el-form-item>
            <el-form-item label="小助手微信二维码" class="is-required">
              <el-upload
                class="avatar-uploader"
                :action="commonUrl.uploadImg"
                :headers="commonUrl.headers"
                style="display: inline-block"
                ref="drainQrCode"
                :data="mediaObj"
                :multiple="false"
                :before-upload="(e) => beforeUpload(e, 'drainQrCode')"
                :on-success="(e) => uploadSuccess(formValue, e, 'drainQrCodeUrl')"
                accept="image/png, image/jpeg, image/jpg"
                :show-file-list="false"
              >
                <div v-if="formValue.drainQrCodeUrl" class="avatar">
                  <img :src="commonUrl.imgPrefix_qN + formValue.drainQrCodeUrl" />
                  <i class="el-icon-edit avatar_edit"></i>
                </div>
                <i v-else class="iconfont icon-picture-add"></i>
              </el-upload>
              <span class="desc">520px*520px以内，大小不超出1mb;支持jpg、png</span>
            </el-form-item>
            <el-form-item label="弹窗图片" class="is-required">
              <el-upload
                class="avatar-uploader"
                :action="commonUrl.uploadImg"
                :headers="commonUrl.headers"
                style="display: inline-block"
                ref="drainPop"
                :data="mediaObj"
                :multiple="false"
                :before-upload="(e) => beforeUpload(e, 'drainPop')"
                :on-success="(e) => uploadSuccess(formValue, e, 'drainPopPic')"
                accept="image/png, image/jpeg, image/jpg, image/gif"
                :show-file-list="false"
              >
                <div v-if="formValue.drainPopPic" class="avatar">
                  <img :src="commonUrl.imgPrefix_qN + formValue.drainPopPic" />
                  <i class="el-icon-edit avatar_edit"></i>
                </div>
                <i v-else class="iconfont icon-picture-add"></i>
              </el-upload>
              <span class="desc">600px*800px，大小不超出1mb;支持jpg、png</span>
            </el-form-item>
          </section>
        </div>
      </el-form>
      <!-- 班级管理 -->
      <el-button
        type="primary"
        size="small"
        style="margin-bottom: 10px"
        @click="skuDailogAdd"
        v-if="PAGEKEY !== 'hospital_vip_bill_detail'"
      >
        添加SKU+</el-button
      >
      <el-table :data="skus" border style="width: 100%" class="table_list" :key="tableKey">
        <el-table-column prop="skuName" label="SKU名称" width="180"> </el-table-column>
        <el-table-column prop="skuDescribe" label="SKU描述" width="180"> </el-table-column>
        <el-table-column prop="vipCardName" label="关联卡片" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.vipCardList | vipCardFilter }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="总金额（元）">
          <template slot-scope="scope">
            <div>￥{{ exchange.parseWallet(scope.row.price) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-switch
              @change="changeStatus(scope.row, scope.$index)"
              v-model="scope.row.status"
              :active-value="true"
              :inactive-value="false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :disabled="isDisabled"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150px">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button type="primary" size="small"> 操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown" class="table_dropdown">
                <el-dropdown-item @click.native="skuDailogEdit(scope.row, scope.$index)"> 编辑</el-dropdown-item>
                <el-dropdown-item @click.native="skuDelete(scope.$index)" v-if="PAGEKEY !== 'hospital_vip_bill_detail'">
                  删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- footer -->
      <el-form ref="form2" label-width="200px" style="padding-top: 30px" v-if="PAGEKEY !== 'hospital_vip_bill_detail'">
        <el-form-item style="margintop: 40px">
          <el-button type="warning" @click="closePage()">取 消</el-button>
          <el-button type="primary" @click="saveHandle()">保 存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 编辑SKU -->
    <el-dialog
      :title="skuDailog.title"
      width="800px"
      :close-on-click-modal="false"
      @closed="resetClassDailog"
      :visible.sync="skuDailog.show"
      center
    >
      <el-form label-width="100px" style="text-align: left">
        <el-form-item label="SKU名称：" class="is-required">
          <el-input
            size="small"
            type="text"
            maxLength="10"
            style="width: 250px"
            v-model.trim="skuDailogData.skuName"
            placeholder="请输入..."
          >
          </el-input>
          <span>10个字以内</span>
        </el-form-item>
        <el-form-item label="SKU描述：" class="is-required">
          <el-input
            size="small"
            type="text"
            maxLength="15"
            style="width: 250px"
            v-model.trim="skuDailogData.skuDescribe"
            placeholder="请输入..."
          >
          </el-input>
          <span>15个字以内</span>
        </el-form-item>
        <el-form-item label="价格：" class="is-required">
          <el-input-number
            style="width: 250px"
            v-model.trim="skuDailogData.price"
            placeholder="请输入价格"
            size="small"
            :min="0"
            :max="999999.9"
            :precision="1"
          >
          </el-input-number>
          <span>元 6位数以内</span>
        </el-form-item>
        <el-form-item label="关联卡片：">
          <el-cascader
            v-if="PAGEKEY !== 'hospital_vip_bill_detail'"
            ref="cascader"
            v-model="skuDailogData.vipCardIdList"
            :options="vipCardTypes"
            :props="{ label: 'name', value: 'id', multiple: true }"
            :show-all-levels="false"
            @change="chooseVipCard"
          ></el-cascader>

          <div v-else>
            {{ skuDailogData.vipCardList | vipCardFilter }}
          </div>

          <!-- 新增一条 -->
          <!-- <i class="el-icon-circle-plus-outline"
             style="color: green; font-size: 20px;margin-left: 10px"
             @click="addVipCardTemplate"></i> -->

          <!-- 删除一条 -->
          <!-- <i class="el-icon-remove-outline"
             style="color: red; font-size: 20px; margin-left: 10px"
             @click="removeVipCardTemplate(index)"
             v-if="skuDailogData.vipCardList.length > 1"></i> -->
        </el-form-item>
        <el-form-item label="权益描述：" class="is-required">
          <v-editor
            :defaultMsg="skuDailogData.rightsDescribe"
            :config="editorDefault.config"
            ref="ueditorWeb"
            :editorId="editorDefault.editorId"
          ></v-editor>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="PAGEKEY !== 'hospital_vip_bill_detail'">
        <el-button @click="skuDailog.show = false">取 消</el-button>
        <el-button type="primary" @click="skuDailogSubmit">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script scoped>
import commonReq from '@/api/common'
import UE from '@/components/uedtior'
import exchange from '@/utils/exchange'
import requestApi from '@/api/thirdManage/hospital_vip_pay'
import vipCardApi from '@/api/operateManage/vipCard'
import vipTypeApi from '@/api/operateManage/vipType'

export default {
  name: 'hospital_vip_bill',
  components: {
    'v-editor': UE
  },
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      commonUrl: commonReq.commonUrl,
      exchange: exchange,
      /*基本信息*/
      name: '', //名称
      orderIntermediaryName: '',
      /*管理*/
      skus: [],
      tableKey: 0,
      // 添加/编辑班级
      skuDailogData: {
        vipCardIds: '',
        vipCardIdList: [],
        vipCardList: []
      },
      skuDailog: {
        show: false,
        type: 1, //1添加 2修改
        title: '编辑SKU',
        price: '',
        rightsDescribe: '',
        skuDescribe: '',
        skuName: '',
        vipCardTypeId: ''
      },
      // ue
      editorDefault: {
        editorId: new Date().getTime().toString(),
        defaultMsg: '',
        config: {
          initialFrameWidth: 500,
          initialFrameHeight: 550,
          autoHeightEnabled: false
        }
      },
      mediaObj: {
        mediaJson: JSON.stringify({
          appType: 3,
          type: 1,
          picContent: { suffix: 'png' }
        })
      },
      vipCardList: [],
      vipCardTypes: [],
      formValue: {
        vipType: null, // 会员类型 1-团购会员 2-个人会员
        drainStatus: 'DISABLED', // DISABLED:关闭 ENABLED:开启
        autoOpenNum: 9999, //自动开通人数设置
        drainTips: '', // 引流提示文案
        drainQrCodeUrl: '', // 引流二维码
        drainPopPic: '' // 引流弹窗图片
      }
    }
  },
  mounted() {
    this.getVipTypes()
    // this.getVipCards()
  },
  computed: {
    isDisabled() {
      return this.PAGEKEY === 'hospital_vip_bill_detail'
    }
  },
  activated() {
    if (this.$route.params.id == this.id) {
      return
    }
    this.id = this.$route.params.id
    this.getData()
  },
  methods: {
    // 获取所有VIP卡种
    handleVipCardTypeChange(type, index) {
      this.getVipCards(type.id, index)
      // this.$set(this.skuDailogData, 'vipCardId', [])
    },
    async getVipTypes() {
      await vipTypeApi.getList(1, 999, { name: '' }).then((res) => {
        if (res.Success) {
          const list = res.Data.dataList || []
          this.vipCardTypes = list.sort((a, b) => a.id - b.id)
        }
      })
      for (let i = 0; i < this.vipCardTypes.length; i++) {
        this.getVipCards(i)
      }
    },

    async getVipCards(index) {
      const vipCardType = this.vipCardTypes[index]
      const query = {
        name: '',
        type: 3, // 3 正价卡、2 团购卡、 1体验卡
        vipCardTypeId: vipCardType.id || '',
        status: 1
      }
      vipCardApi.getList(1, 999, query).then((res) => {
        if (res.Success) {
          // this.vipCardList = res.Data.dataList
          vipCardType.children = res.Data.dataList || []
        } else {
          this.$message.error(res.Msg)
          return []
        }
      })
    },
    getData() {
      requestApi
        .detail({
          id: this.id
        })
        .then((res) => {
          if (res.Success) {
            this.skus = res.Data.skus || []
            this.name = res.Data.name
            this.orderIntermediaryName = res.Data.orderIntermediaryName
            this.formValue = res.Data
          } else {
            this.$message.error(res.Msg)
          }
        })
    },
    saveHandle() {
      let data = this.formValue
      data.name = this.name
      data.orderIntermediaryName = this.orderIntermediaryName
      if (!data.name) {
        this.$message.warning('请填写名称')
        return
      }
      if (!data.orderIntermediaryName) {
        this.$message.warning('请填写订单媒介来源名称')
        return
      }
      if (!data.vipType) {
        this.$message.warning('请选择订单会员类型')
        return
      }
      if (data.drainStatus === 'ENABLED' && !data.drainTips) {
        this.$message.warning('请填写引流提示文案')
        return
      }
      if (data.drainStatus === 'ENABLED' && (!data.drainQrCodeUrl || !data.drainPopPic)) {
        this.$message.warning('请上传引流图片')
        return
      }
      if (!this.skus.length) {
        this.$message.warning('请添加sku')
        return
      }
      // 必须有一个开启的sku
      let hasSku = this.skus.find((item) => item.status === true)
      if (!hasSku) {
        this.$message.warning('请开启一个sku')
        return
      }

      if (this.formValue.vipType !== 1) {
        delete data.autoOpenNum
      }

      if (this.id) {
        data.id = this.id
      }
      if (this.PAGEKEY === 'hospital_vip_bill_copy') {
        data.id = ''
      }
      if (this.formValue.drainStatus === 'DISABLED') {
        delete data.drainTips
        delete data.drainQrCodeUrl
        delete data.drainPopPic
      }
      data.skus = this.skus
      requestApi.savePay(data).then((res) => {
        if (res.Success) {
          this.$message.success('操作成功')
          this.closePage()
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    // 添加班级
    skuDailogAdd() {
      this.skuDailog.title = '编辑SKU'
      this.skuDailog.type = 1
      this.skuDailog.index = -1
      this.skuDailogData.rightsDescribe = ''
      this.skuDailogData.vipCardIds = ''
      this.skuDailogData.vipCardIdList = []
      this.skuDailogData.vipCardList = []
      this.skuDailog.show = true
    },
    // 编辑班级
    skuDailogEdit(item, index) {
      this.skuDailog.title = '编辑SKU'
      this.skuDailog.type = 2
      this.skuDailogData = JSON.parse(JSON.stringify(item))
      this.skuDailogData.price = this.skuDailogData.price / 100
      this.skuDailog.show = true
      this.skuDailog.index = index
      if (!this.skuDailogData.vipCardIdList) {
        this.skuDailogData.vipCardIdList = this.skuDailogData.vipCardList
          ? this.skuDailogData.vipCardList.map((item) => [item.vipCardTypeId, item.id])
          : []
      }
    },
    // 添加/编辑SKU
    skuDailogSubmit() {
      let skuDailogData = JSON.parse(JSON.stringify(this.skuDailogData))
      skuDailogData.status = this.skuDailogData.status || false
      skuDailogData.rightsDescribe = this.$refs.ueditorWeb.getUEContent()
      if (
        !skuDailogData.skuName ||
        !skuDailogData.skuDescribe ||
        !skuDailogData.price ||
        !skuDailogData.rightsDescribe
      ) {
        this.$message.warning('您有信息未填写')
        return
      }
      skuDailogData.vipCardIdList = skuDailogData.vipCardIdList || []
      if (skuDailogData.vipCardIdList.length && skuDailogData.vipCardIdList.length > 5) {
        this.$message.warning('最多只能选择5个卡片')
        return
      }
      const vipCardIdList = skuDailogData.vipCardIdList.map((item) => item[1])
      skuDailogData.vipCardIds = vipCardIdList.join(',')
      skuDailogData.vipCardList = skuDailogData.vipCardList.filter((item) => vipCardIdList.includes(item.id))
      skuDailogData.price = skuDailogData.price * 100
      if (this.skuDailog.index >= 0) {
        this.$set(this.skus, this.skuDailog.index, skuDailogData)
      } else {
        this.skus.push(skuDailogData)
      }
      this.skuDailog.show = false
    },
    skuDelete(index) {
      this.skus.splice(index, 1)
    },
    changeStatus(row) {
      this.$set(row, 'status', row.status)
      this.tableKey++
    },
    resetClassDailog() {
      this.skuDailogData = {
        skuName: '',
        skuDescribe: '',
        rightsDescribe: '',
        prices: 0
      }
      this.$refs.ueditorWeb.setUEContent('')
    },
    beforeUpload(file, refName) {
      if (file.size > 1024 * 1024) {
        this.$refs[refName].abort(file)
        this.$message.error('当前上传的图片已超过1MB，无法上传，请重新选择')
        return false
      }
    },
    uploadSuccess(query, res, key) {
      res = this.$apiOldResDeal(res)
      console.log(query, res, key) //
      debugger
      if (res.Success) {
        query[key] = res.Data.url
      } else {
        this.$message.error(res.Msg)
      }
    },
    chooseVipCard() {
      const nodes = this.$refs.cascader.getCheckedNodes(true)
      this.skuDailogData.vipCardList = nodes.map((node) => node.data)
    },
    addVipCardTemplate() {
      this.skuDailogData.vipCardList.push({})
    },
    removeVipCardTemplate(index) {
      this.skuDailogData.vipCardList.splice(index, 1)
    },
    //取消钩子
    closePage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    }
  },
  filters: {
    vipCardFilter(list) {
      list = list || []
      const listStr = list.map((item) => item.name || '').join('，')
      return listStr
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.avatar-uploader {
  display: inline-block;
}
.self-el-card {
  margin-bottom: 20px;
}
.self-el-tag {
  margin-right: 10px;
}
.desc {
  color: #777;
}
.width_short_half {
  width: 10%;
  min-width: 150px;
}
.link {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
}

.box-input {
  width: 500px;
}
.pay-success-card {
  background-color: #fafafa;
  padding: 10px;
  box-shadow: 4px 4px 4px #f3f3f3;
  border-radius: 5px;
  margin-bottom: 10px;
  &:hover {
    box-shadow: 5px 5px 5px #f0f0f0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/thirdManage/hospital_vip_pay/components/bill.vue